import { Typography } from '@mui/material'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { useAppSelector } from 'store/configureStore'
import { makeStyles } from 'tss-react/mui'
import { bomItemRowNumberSelector } from '../store/selectors/bomItemNumberSelector'

const useStyles = makeStyles()(() => ({
  circularProgressFix: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
}))

export const BomItemRowNumber = ({
  bomItemPointer,
}: {
  bomItemPointer: BomItemPointer
}) => {
  const { classes } = useStyles()

  const bomItemRowNumber = useAppSelector(
    bomItemRowNumberSelector(bomItemPointer),
  )

  if (!bomItemRowNumber || bomItemRowNumber <= 0) {
    return null
  }

  return (
    <Typography
      variant="caption"
      color="textSecondary"
      component="div"
      style={{
        fontVariantNumeric: 'tabular-nums',
      }}
      className={classes.circularProgressFix}
    >
      {bomItemRowNumber}
    </Typography>
  )
}
